import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

import { CPermission } from "src/1/common/components/others";
import { history } from "src/App";

import { SIDEBAR_WIDTH } from "../../../constants";

export const CPopoverMenu = ({
  open,
  data,
  onMoveToPopover,
  closePopover,
  isCentral,
}) => {
  //#region Data
  const [viewportPosition, setViewportPosition] = useState(null); // track whether it's outside and on which side

  const location = useLocation();

  const popoverRef = useRef(null);
  //#endregion

  //#region Event
  const onClick = (path) => () => {
    history.push(path);
    closePopover();
  };

  const isThisItemSelected = (path) => {
    return location.pathname.startsWith(path);
  };
  //#endregion

  useEffect(() => {
    if (popoverRef.current) {
      const rect = popoverRef.current.getBoundingClientRect();
      let position = null;

      // Kiểm tra xem phần tử có nằm ngoài vùng nhìn hay không
      if (rect.top < 0) {
        position = "top"; // Phần tử bị tràn ra trên
      } else if (rect.bottom > window.innerHeight) {
        position = "bottom"; // Phần tử bị tràn ra dưới
      }

      setViewportPosition(position); // Cập nhật trạng thái với vị trí tràn
    }
  }, [open]); // Chạy lại khi `open` thay đổi

  //#region Render
  return (
    <div
      ref={popoverRef}
      onMouseEnter={onMoveToPopover}
      onMouseLeave={closePopover}
      className={classNames(
        "absolute rounded-xl shadow-xl z-50 text-[#053C7F] !border !border-solid !border-blue-200 overflow-hidden",
        open ? "block" : "hidden",
        isCentral && "text-[#0D9488]",
      )}
      style={{
        left: `${SIDEBAR_WIDTH.MINI}px`,
        transform:
          viewportPosition === null
            ? "translateY(-35%)"
            : viewportPosition === "top"
              ? "translateY(-20%)"
              : "translateY(-90%)",
        width: 300,
        background: "white",
      }}
    >
      <h6 className="!px-4 !py-2 whitespace-nowrap mb-0 text-lg bg-blue-50">
        {data?.name}
      </h6>
      {data?._children?.map((e, i) => (
        <CPermission key={e?.name + e?.to + i} permissions={e.permissions}>
          <div
            className={classNames(
              "!px-4 !py-2 whitespace-nowrap text-base cursor-pointer hover:bg-[#d2dff5]",
              isThisItemSelected(e?.to) &&
                "nav-selected bg-blue-200 hover:bg-blue-200",
            )}
            onClick={onClick(e?.to)}
          >
            {e?.name}
          </div>
        </CPermission>
      ))}
    </div>
  );
  //#endregion
};
